// extracted by mini-css-extract-plugin
export default {"label":"CustomInput_label__Fz6Yf","label__title":"CustomInput_label__title__f6V7I","label__input":"CustomInput_label__input__p3ejL"};